import { Field } from 'components/Form/Field/Field';
import { Input } from 'components/Input/Input';

type Props = {
  'data-qa-id'?: string;
  name: string;
  label?: string;
  description?: string;
  placeholder?: string;
  id?: string;
  disabled?: boolean;
  onChange: (newValue: string) => void;
  type: 'URL';
};

export function RequestedURLUserField({
  'data-qa-id': qaId,
  name,
  label,
  description,
  disabled,
  type,
  id,
  placeholder,
  onChange,
}: Props) {
  if (type !== 'URL') return null;
  const subName = `${name}.${type.toLowerCase()}`;

  return (
    <Field
      customErrorMatch={(errors) => errors[name] ?? errors[subName]}
      name={name}
      label={label}
      description={description}
      renderInput={({ value, qaId: autoQaId, updateValue }) => (
        <Input
          inputProps={{
            name,
            disabled,
            id,
            placeholder,
            qaId: `${qaId ?? autoQaId}-hidden-input`,
            value: value ? value.url : '',
            type: 'text',
            onChange: (e) => {
              const v = e.target.value;

              onChange(v);

              updateValue(
                v
                  ? {
                      type: 'URL',
                      url: v,
                    }
                  : null,
              );
            },
          }}
        />
      )}
    />
  );
}
